import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import UserContext from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom'; 
import { IoMdAdd } from "react-icons/io";
import displayError from '../../utils/ErrorHandler';
import authenticate from '../../utils/Authenticate';
import { set } from 'mongoose';
import { getActiveZoneId } from '../../utils/zoneSession';
import { n2 } from '../../utils/fmt';

const ItemOutPage = () => {
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [stock, setStock] = useState([]);
  const [miqaatList, setMiqaatList] = useState([]);
  const [selectedMiqaat, setSelectedMiqaat] = useState(null);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchItem, setSearchItem] = useState('');
  const [quantity, setQuantity] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [addedItems, setAddedItems] = useState([]);
  const [error, setError] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [pendingMiqaat, setPendingMiqaat] = useState('');
  const navigate = useNavigate();
  const [error2, setError2] = useState(null);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');
  const [selectedMenu, setSelectedMenu] = useState('');
  const [loading, setLoading] = useState(true);
  const [menus, setMenus] = useState([]);
  const [thaal, setThaal] = useState(0);
  const [mumineenCount, setMumineenCount] = useState(0);
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [remarks, setRemarks] = useState('');
  
  // New states for menu suggestions
  const [menuDetails, setMenuDetails] = useState(null);
  const [suggestedItems, setSuggestedItems] = useState([]);
  const [loadingMenuDetails, setLoadingMenuDetails] = useState(false);

  // Slip-image extraction state
  const [slipUploading, setSlipUploading] = useState(false);
  const [slipError, setSlipError] = useState('');
  const [unmatchedFromSlip, setUnmatchedFromSlip] = useState([]);
  const [uncertainItemKeys, setUncertainItemKeys] = useState(new Set());

  const createMiqaat = async () => {
    navigate("/zc/create-miqaat");
  };

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
    }
    startup();
  }, [user])

  useEffect(() => {
    // getMiqaat();
    getItems();
  }, []);

  useEffect(() => {
    console.log(user);
    const fetchMenus = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URI}/api/menu/getAll`, { withCredentials: true });
        console.log(response.data);
        setMenus(response.data.data);
      } catch (error) {
        console.error('Error fetching menus:', error);
        setNotification({ message: 'Error fetching menus', type: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchMenus();
  }, []);

  // const getMiqaat = async () => {
  //   try {
  //     const response = await axios.get(`${process.env.REACT_APP_API_URI}/api/miqaat/get`, { withCredentials: true });
  //     setMiqaatList(response.data.data);
  //   } catch (error) {
  //     console.error('Error fetching miqaat:', error);
  //   }
  // };

  const getItems = async () => {
    try {
  const zoneIdForReq = user?.zone?._id || getActiveZoneId();
  const response = await axios.get(`${process.env.REACT_APP_API_URI}/api/stock/get?id=${zoneIdForReq}`, { withCredentials: true });
      if (response.data.success) {
        setStock(response.data.data);
        setFilteredItems(response.data.data);
      }
    } catch (err) {
      const errorMessage = displayError(err, navigate, setUser);
      console.log(errorMessage);
      if (errorMessage) {
        setMessage(errorMessage)
      }
    }
  };

  // Process menu ingredients against user stock
  const processMenuIngredients = (menuData, userStock, thaal) => {
    const suggestedItemsMap = new Map(); // Use Map to avoid duplicates
    
    menuData.dishes.forEach(dish => {
      dish.dish.ingredients.forEach(ingredient => {
        // Find this ingredient in user's stock
        console.log("ingredient");
        console.log(ingredient);
        console.log(dish);
        console.log(selectedMiqaat);
        console.log(thaal);
        const stockItem = userStock.find(s => s.item._id === ingredient.name._id);
        
        if (stockItem && stockItem.quantity > 0) {
          const ingredientId = ingredient.name._id;
          
          // Calculate suggested quantity (ingredient.quantity * dish.perThaalQuantity)
          const calculatedQty = ingredient.quantity * dish.dish.quantity * thaal;
          console.log("Calculated quantity: " + calculatedQty);
          
          // If item already exists in suggestions, add to the quantity
          if (suggestedItemsMap.has(ingredientId)) {
            const existingItem = suggestedItemsMap.get(ingredientId);
            existingItem.calculatedQuantity += calculatedQty;
          } else {
            suggestedItemsMap.set(ingredientId, {
              stockItem: stockItem,
              calculatedQuantity: calculatedQty,
              editableQuantity: calculatedQty,
              ingredient: ingredient
            });
          }
        }
      });
    });

    // Convert Map to Array and limit quantities to available stock
    const processed = Array.from(suggestedItemsMap.values()).map(item => ({
      ...item,
      editableQuantity: Math.min(item.calculatedQuantity, item.stockItem.quantity),
      maxAvailable: item.stockItem.quantity
    }));

    return processed;
  };

  const handleSearchChange = (e) => {
    setSearchItem(e.target.value);
    if (e.target.value) {
      const filtered = stock.filter(item =>
        item.item.name.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setFilteredItems(filtered);
    } else {
      setFilteredItems(stock);
    }
  };

  const handleItemSelect = (item) => {
    setSelectedItem(item);
    setSearchItem(item.item.name);
    setFilteredItems([]);
    setShowDropdown(false);
    setError('');
  };

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    // Allow numbers and decimal points
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setQuantity(value);
      if (selectedItem && parseFloat(value) > selectedItem.quantity) {
        setError('Not enough stock');
      } else {
        setError('');
      }
    }
  };

  const handleAddItem = () => {
    const qty = parseFloat(quantity);
    if (selectedItem && quantity && qty <= selectedItem.quantity && qty > 0) {
      const updatedItems = [...addedItems];
      const existingItemIndex = updatedItems.findIndex(item => item.item._id === selectedItem.item._id);
      if (existingItemIndex >= 0) {
        updatedItems[existingItemIndex].quantity = quantity;
      } else {
        updatedItems.push({ ...selectedItem, quantity });
      }
      setAddedItems(updatedItems);
      setSearchItem('');
      setQuantity('');
      setSelectedItem(null);
      setError('');
    } else if (qty > selectedItem.quantity) {
      setError('Not enough stock');
    } else if (qty <= 0) {
      setError('Quantity must be greater than 0');
    }
  };

  const handleSlipImageUpload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = ''; // allow re-selecting the same file later
    if (!file) return;

    setSlipUploading(true);
    setSlipError('');
    setUnmatchedFromSlip([]);

    try {
      const zoneIdForReq = user?.zone?._id || getActiveZoneId();
      const formData = new FormData();
      formData.append('slip', file);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/api/stock/extractItemOutFromImage?id=${zoneIdForReq}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' }, withCredentials: true }
      );

      const data = response.data.data;
      if (typeof data.thaal === 'number') setThaal(data.thaal);
      if (typeof data.mumineen === 'number') setMumineenCount(data.mumineen);

      const newUncertainKeys = new Set(uncertainItemKeys);
      const updatedItems = [...addedItems];

      (data.items || []).forEach((extractedItem) => {
        if (!extractedItem.quantity) return; // couldn't read a usable quantity, leave for manual entry
        const stockItem = stock.find(s => s.item._id === extractedItem.itemId);
        if (!stockItem) return;

        const existingIndex = updatedItems.findIndex(it => it.item._id === extractedItem.itemId);
        if (existingIndex >= 0) {
          updatedItems[existingIndex].quantity = extractedItem.quantity;
        } else {
          updatedItems.push({ ...stockItem, quantity: extractedItem.quantity });
        }

        if (extractedItem.uncertain) newUncertainKeys.add(extractedItem.itemId);
        else newUncertainKeys.delete(extractedItem.itemId);
      });

      setAddedItems(updatedItems);
      setUncertainItemKeys(newUncertainKeys);
      setUnmatchedFromSlip(data.unmatched || []);
    } catch (err) {
      const errorMessage = displayError(err, navigate, setUser);
      setSlipError(errorMessage || 'Could not read the slip image — please add items manually.');
    } finally {
      setSlipUploading(false);
    }
  };

  const handleFocus = () => {
    setShowDropdown(true);
    setFilteredItems(stock);
  };

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 200);
  };

  const stockOut = async (stockoutObj) => {
    try {
      const zoneIdForReq = user?.zone?._id || getActiveZoneId();
      const response = await axios.post(`${process.env.REACT_APP_API_URI}/api/stock/remove?id=${zoneIdForReq}`, stockoutObj, { withCredentials: true });
      if (response.data.message === "Stock updated successfully!") {
        setSuccess(true);
        setAddedItems([]);
        setSuggestedItems([]);
        setPendingMiqaat('');
        setSelectedMiqaat(null);
        setSelectedMenu('');
        setMenuDetails(null);
        setButtonDisabled(false);
        setRemarks('');
        await getItems();
      }
    } catch (error) {
      setError2(error);
    }
  };

  const handleSubmit = () => {
    setButtonDisabled(true);
    const items = addedItems.map(item => ({
      name: item.item.name,
      quantity: item.quantity,
    }));

    const stockoutObj = {
      items: items,
      menu: selectedMiqaat._id,
      thaal: thaal,
      mumineen: mumineenCount,
      remarks: remarks.trim(),
    };

    stockOut(stockoutObj);
  };

  const handleMiqaatChange = (e) => {
    if (addedItems.length > 0) {
      setPendingMiqaat(e.target.value);
      setShowWarning(true);
    } else {
      setSelectedMiqaat(e.target.value);
    }
  };

  const confirmMiqaatChange = () => {
    setSelectedMiqaat(pendingMiqaat);
    setAddedItems([]);
    setPendingMiqaat('');
    setShowWarning(false);
  };

  const handleDeleteItem = (index) => {
    const updatedItems = [...addedItems];
    updatedItems.splice(index, 1);
    setAddedItems(updatedItems);
  };

  const handleMenuChange = async (e) => {
    console.log(e.target.value);
    const miqaat = menus.find(miqaat => miqaat._id === e.target.value);
    setSelectedMiqaat(miqaat);
    console.log(miqaat);
    const menuId = miqaat._id;

    setSelectedMenu(e.target.value);
    
    if (menuId) {
      try {
        setLoadingMenuDetails(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URI}/api/dish/${menuId}/getIngredients`, { withCredentials: true });
        console.log('Menu details:', response.data);
        setMenuDetails(response.data.data);
        setThaal(response.data.data.miqaat?.thaal||1);
        setMumineenCount(response.data.data.miqaat?.mumineenCount||0);
        
        // Process ingredients and create suggestions
        const thaalCount = response.data.data.miqaat?.thaal || 1;
        const suggestions = processMenuIngredients(response.data.data, stock,thaalCount);      
        setSuggestedItems(suggestions);
        
      } catch (error) {
        console.error('Error fetching menu details:', error);
        setNotification({ message: 'Error fetching menu details', type: 'error' });
      } finally {
        setLoadingMenuDetails(false);
      }
    } else {
      setMenuDetails(null);
      setSuggestedItems([]);
    }
  };

  // Handle suggested item quantity change
  const handleSuggestedQuantityChange = (index, value) => {
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      const updatedSuggestions = [...suggestedItems];
      const numValue = parseFloat(value) || 0;
      
      // Limit to available stock
      if (numValue <= updatedSuggestions[index].maxAvailable) {
        updatedSuggestions[index].editableQuantity = value;
        setSuggestedItems(updatedSuggestions);
      }
    }
  };

  // Add suggested item to cart
  const handleAddSuggestedItem = (index) => {
    const suggestedItem = suggestedItems[index];
    const qty = parseFloat(suggestedItem.editableQuantity);
    
    if (qty > 0) {
      const updatedItems = [...addedItems];
      const existingItemIndex = updatedItems.findIndex(item => item.item._id === suggestedItem.stockItem.item._id);
      
      if (existingItemIndex >= 0) {
        updatedItems[existingItemIndex].quantity = suggestedItem.editableQuantity;
        updatedItems[existingItemIndex].definedQuantity = suggestedItem.calculatedQuantity;
      } else {
        updatedItems.push({
          ...suggestedItem.stockItem,
          quantity: suggestedItem.editableQuantity,
          // System-calculated baseline, carried over so the cart can still show
          // it for comparison even after the item has been added.
          definedQuantity: suggestedItem.calculatedQuantity
        });
      }
      setAddedItems(updatedItems);
    }
  };

  // Remove suggested item
  const handleRemoveSuggestedItem = (index) => {
    const updatedSuggestions = [...suggestedItems];
    updatedSuggestions.splice(index, 1);
    setSuggestedItems(updatedSuggestions);
  };

  // Add all suggested items
  const handleAddAllSuggested = () => {
    const validSuggestions = suggestedItems.filter(item => parseFloat(item.editableQuantity) > 0);
    const newItems = [...addedItems];
    
    validSuggestions.forEach(suggestedItem => {
      const existingItemIndex = newItems.findIndex(item => item.item._id === suggestedItem.stockItem.item._id);
      
      if (existingItemIndex >= 0) {
        newItems[existingItemIndex].quantity = suggestedItem.editableQuantity;
        newItems[existingItemIndex].definedQuantity = suggestedItem.calculatedQuantity;
      } else {
        newItems.push({
          ...suggestedItem.stockItem,
          quantity: suggestedItem.editableQuantity,
          definedQuantity: suggestedItem.calculatedQuantity
        });
      }
    });
    
    setAddedItems(newItems);
  };

  return (
    <>
      <div className="bg-lime-800 flex items-center justify-between w-full p-4 text-white fixed z-10">
        <h4 className="text-lg md:text-xl font-semibold text-center flex-grow">Items Check Out</h4>
      </div>
      {message ?
        <div className="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span className="block sm:inline">{message}</span>
          <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        : null}
      <div className="p-4 max-w-xl mx-auto pt-[70px]">
        {error2 && <div className="bg-red-100 text-red-700 p-2 mb-4">{error2}</div>}
        {success && <div className="bg-green-100 text-green-700 p-2 mb-4">Inventory Updated!</div>}
        {showWarning && (
          <div className="mb-4 p-4 border border-red-500 bg-red-100 rounded-md">
            <p className="text-sm text-red-700">Changing the miqaat will clear all added items. Do you want to continue?</p>
            <div className="mt-2 flex justify-end">
              <button
                onClick={() => setShowWarning(false)}
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md mr-2"
              >
                Cancel
              </button>
              <button
                onClick={confirmMiqaatChange}
                className="px-4 py-2 bg-red-500 text-white rounded-md"
              >
                Continue
              </button>
            </div>
          </div>
        )}

        {/* Menu Selection */}
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="menu-select">
            Select Menu
          </label>
          <select 
            id="menu-select"
            value={selectedMenu} 
            onChange={handleMenuChange}
            disabled={loading}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            required
          >
            <option value="">
              {loading ? 'Loading menus...' : 'Choose a menu'}
            </option>
            {menus.map((menu) => (
              <option key={menu._id} value={menu._id}>
                {menu.name}
              </option>
            ))}
          </select>
        </div>

        {/* Loading Menu Details */}
        {loadingMenuDetails && (
          <div className="mb-4 text-center">
            <p className="text-gray-600">Loading menu ingredients...</p>
          </div>
        )}

        {
          selectedMenu && !loadingMenuDetails && (
            <div className='flex flex-row justify-between mb-4'>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="thaal">
                Thaal Count
              </label>
              <input
                type="number"
                id="thaal"
                name="thaal"
                value={thaal}
                onChange={(e) => {setThaal(e.target.value);setSuggestedItems(processMenuIngredients(menuDetails, stock, e.target.value));}}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                required
                min="0"
              />
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="mumineenCount">
                Mumineen Count
              </label>
              <input
                type="number"
                id="mumineenCount"
                name="mumineenCount"
                value={mumineenCount}
                onChange={(e) => {setMumineenCount(e.target.value);}}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                required
                min="0"
              />
            </div>
            </div>
          )
        }

        {/* Upload Slip Image */}
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Upload Slip Image (optional)
          </label>
          <p className="text-xs text-gray-500 mb-2">
            Already wrote out the stock-out slip for the cook? Photograph it here and we'll try to pre-fill the items below — review and correct before submitting.
          </p>
          <input
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handleSlipImageUpload}
            disabled={!selectedMenu || slipUploading}
            className={`text-sm block w-full border ${!selectedMenu ? 'bg-gray-200' : 'bg-white'} border-gray-300 rounded-md p-2`}
          />
          {slipUploading && <p className="text-xs text-blue-600 mt-1">Reading slip image...</p>}
          {slipError && <p className="text-xs text-red-600 mt-1">{slipError}</p>}
          {unmatchedFromSlip.length > 0 && (
            <div className="mt-2 p-3 bg-amber-50 border border-amber-200 rounded-md">
              <p className="text-xs font-semibold text-amber-800 mb-1">
                Couldn't match these rows from the slip to a stock item — add them manually if needed:
              </p>
              <ul className="text-xs text-amber-700 list-disc list-inside">
                {unmatchedFromSlip.map((row, idx) => (
                  <li key={idx}>{row.rawName}{row.quantity ? ` — qty ${row.quantity}` : ''}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Suggested Items from Menu */}
        {suggestedItems.length > 0 && (
          <div className="mb-6">
            <div className="flex justify-between items-center mb-3">
              <h3 className="text-md font-semibold text-gray-800">Suggested {menuDetails?.name} Items available in stock</h3>
              <button
                onClick={handleAddAllSuggested}
                className="text-sm bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
              >
                Add All
              </button>
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
              {suggestedItems.map((suggestion, index) => {
                const editableNum = parseFloat(suggestion.editableQuantity);
                const isChanged = !isNaN(editableNum) && Math.abs(editableNum - suggestion.calculatedQuantity) > 0.001;
                return (
                <div key={suggestion.stockItem.item._id} className="flex items-center justify-between py-2 border-b border-blue-200 last:border-b-0">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-gray-800">{suggestion.stockItem.item.name}</p>
                    <p className="text-xs text-gray-600">Available: {suggestion.maxAvailable} {suggestion.stockItem.item.unit}</p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="flex flex-col items-start">
                      <input
                        type="text"
                        value={suggestion.editableQuantity}
                        onChange={(e) => handleSuggestedQuantityChange(index, e.target.value)}
                        className={`w-16 px-2 py-1 text-sm border rounded focus:outline-none focus:ring-1 focus:ring-blue-500 ${isChanged ? 'border-amber-400 bg-amber-50' : 'border-gray-300'}`}
                        placeholder="Qty"
                      />
                      <span className={`text-[10px] mt-0.5 whitespace-nowrap ${isChanged ? 'text-amber-700 font-medium' : 'text-gray-500'}`}>
                        Defined: {n2(suggestion.calculatedQuantity)}{isChanged ? ' (changed)' : ''}
                      </span>
                    </div>
                    <span className="text-xs text-gray-600 w-8">{suggestion.stockItem.item.unit}</span>
                    <button
                      onClick={() => handleAddSuggestedItem(index)}
                      className="text-xs bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded"
                      disabled={!suggestion.editableQuantity || parseFloat(suggestion.editableQuantity) <= 0}
                    >
                      Add
                    </button>
                    <button
                      onClick={() => handleRemoveSuggestedItem(index)}
                      className="text-red-500 hover:text-red-700 text-xs"
                    >
                      ✕
                    </button>
                  </div>
                </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Manual Item Addition */}
        <div className="mb-4">
          <h3 className="text-md font-semibold text-gray-800 mb-3">Add Additional Items</h3>
          <div className="mb-4 relative grid grid-cols-5 gap-2">
            <div className="col-span-3">
              <label className="block text-[13px] font-medium text-gray-700">Item Name</label>
              <input
                type="text"
                value={searchItem}
                onChange={handleSearchChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                disabled={!selectedMenu}
                className={`text-[13px] mt-1 block w-full pl-3 pr-3 py-2 border ${!selectedMenu ? 'bg-gray-200' : 'bg-white'} border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md`}
                placeholder="Search Item"
              />
              {showDropdown && filteredItems.length > 0 && (
                <ul className="border border-gray-300 mt-1 max-h-60 overflow-auto absolute bg-white z-10 w-full">
                  {filteredItems.map(item => (
                    <li
                      key={item._id}
                      className="text-[13px] px-4 py-2 cursor-pointer hover:bg-gray-100"
                      onMouseDown={() => handleItemSelect(item)}
                    >
                      {item.item.name} (Stock: {item.quantity})
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div>
              <label className="block text-[13px] font-medium text-gray-700">Quantity</label>
              <input
                type="text"
                value={quantity}
                onChange={handleQuantityChange}
                disabled={!selectedMenu}
                className={`mt-1 block w-full pl-3 pr-3 py-2 border ${error ? 'border-red-500' : 'border-gray-300'} ${!selectedMenu ? 'bg-gray-200' : 'bg-white'} focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md`}
              />
              {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
            </div>
            <div>
              <label className="block text-[13px] font-medium text-gray-700">Units</label>
              <input
                type="text"
                value={selectedItem ? selectedItem.item.unit : ''}
                disabled
                className="mt-1 block w-full pl-3 pr-3 py-2 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md bg-gray-100"
              />
            </div>
          </div>

          <button
            onClick={handleAddItem}
            disabled={!selectedMenu}
            className="mb-4 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
          >
            Add Item
          </button>
        </div>

        {/* Added Items List */}
        <div className="mt-4">
          {addedItems.length > 0 && (
            <h3 className="text-md font-semibold text-gray-800 mb-3">Items to Remove from Stock</h3>
          )}
          {addedItems.map((item, index) => {
            const isUncertain = uncertainItemKeys.has(item.item._id);
            const hasDefined = item.definedQuantity != null;
            const qtyNum = parseFloat(item.quantity);
            const isChanged = hasDefined && !isNaN(qtyNum) && Math.abs(qtyNum - item.definedQuantity) > 0.001;
            return (
            <div key={index} className={`p-4 bg-white border rounded-md mb-2 flex justify-between items-center transition-all duration-300 hover:bg-gray-100 ${isUncertain ? 'border-amber-400 bg-amber-50' : 'border-gray-300'}`}>
              <p className="text-sm font-medium text-gray-700">
                {item.item.name}
                {isUncertain && (
                  <span className="ml-2 text-[10px] font-semibold text-amber-700 bg-amber-100 border border-amber-300 px-2 py-0.5 rounded-full align-middle">
                    Please verify
                  </span>
                )}
              </p>
              <div className="flex items-center space-x-2">
                <div className="flex flex-col items-end">
                  <p className={`text-sm font-semibold ${isChanged ? 'text-amber-700' : 'text-gray-700'}`}>{item.quantity} {item.item.unit}</p>
                  {hasDefined && (
                    <span className={`text-[10px] ${isChanged ? 'text-amber-700 font-medium' : 'text-gray-500'}`}>
                      Defined: {n2(item.definedQuantity)} {item.item.unit}{isChanged ? ' (changed)' : ''}
                    </span>
                  )}
                </div>
                <button onClick={() => handleDeleteItem(index)} className="text-red-600 hover:text-red-800 focus:outline-none">
                  <svg className="h-5 w-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M14.1 15.3l-1.4 1.4-3.7-3.7-3.7 3.7-1.4-1.4 3.7-3.7-3.7-3.7 1.4-1.4 3.7 3.7 3.7-3.7 1.4 1.4-3.7 3.7 3.7 3.7z"/></svg>
                </button>
              </div>
            </div>
            );
          })}
        </div>
        <div className="mt-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Remarks (Optional)
          </label>
          <textarea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Enter any remarks"
            rows={3}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>

        <button
          onClick={handleSubmit}
          disabled={addedItems.length === 0 || isButtonDisabled === true}
          className={`fixed bottom-[80px] left-1/2 transform -translate-x-1/2 w-11/12 max-w-md inline-flex items-center justify-center px-4 py-2 border border-transparent text-white font-medium rounded-md shadow-sm ${addedItems.length === 0 || isButtonDisabled === true ? 'bg-gray-400' : 'bg-fmb hover:bg-yellow-500'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500`}
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default ItemOutPage;